import { Card, Image } from 'semantic-ui-react'
import * as React from 'react'

type QrCodeImageProps = {
  src: string,
  description?: string
}

export const QrCodeImage: React.SFC<QrCodeImageProps> = (props) => {
  const description = props.description ? props.description
    : 'Quét QR để chuyển khoản nhanh hơn, tự điền stk và nội dung để tránh nhầm lẫn'
  return (
    <Card>
      <Image src={props.src}/>
      <Card.Content>
        <Card.Description>
          {description}
        </Card.Description>
      </Card.Content>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/components/QrCodeImage.tsx